import { MenuItem, Popover } from '@mui/material';
import { useAuth } from '../../hooks/use-auth';

const vistas = [
  "Vista administrador",
  "Vista distribuidora",
  "Vista agente"
];

export const OrganizationPopover = (props) => {
  const { anchorEl, onClose, open, ...other } = props;

  const handleChange = (organization) => {
    if (organization === 'Vista administrador') {
      changeRole('administrador');
    } else if (organization === 'Vista distribuidora') {
      changeRole('distribuidora');
    } else if (organization === 'Vista agente') {
      changeRole('agente');
    }
    onClose?.();
  };

  const { user, role, changeRole } = useAuth();

  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{
        horizontal: 'left',
        vertical: 'bottom'
      }}
      keepMounted
      onClose={onClose}
      open={!!open}
      PaperProps={{ sx: { width: 248 } }}
      transitionDuration={0}
      {...other}>
      {vistas.map((organization) => (
        <MenuItem
          key={organization}
          onClick={() => handleChange(organization)}
        >
          {organization}
        </MenuItem>
      ))}
    </Popover>
  );
};
